import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Leadingdemand(props) {
    return (
        <section className="p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Retail Software">
                            <h2>Retail Software Development To Streamline Inventory Management</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>TekRevol is a leading software development company empowering retail enterprises to
                            streamline retail operations, including inventory management, sales management, payment
                            management, and more. Whether you’re a consumer-based retail business or a corporate
                            enterprise working in the HORECA (hotels, restaurants, and cafes) industry, TekRevol can
                            help you build retail management software to get a definite edge over the competition and
                            serve your customers with ease. </p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Leadingdemand;